module.exports = {
  billing_reconciliation: 'Reconciliation',
  billing_bill: 'Debit note Credit note',
  billing_accountStatement: 'Account Statement',
  billing_cancel: 'Cancel',
  billing_return: 'Return',
  billing_save: 'Save',
  billing_edit: 'Edit',
  billing_collectInvoice: 'Collect Invoice',
  billing_drawInvoice: 'Draw Invoice',
  billing_writeOff: 'Write-Off',
  billing_applyForPayment: 'Request withdraw',
  billing_paymentBillState: 'Payment bill state',
  billing_print: 'Print',
  billing_adjustBillDate: 'Adjust Bill Date',
  billing_addCharges: 'add fees and charges',
  billing_deleteCharges: 'remove fees and charges',
  billing_deleteAll: 'remove all',
  billing_viewDeleteAll: 'View/Delete charge detail',
  billing_newAdjustment: 'New Adjustment',
  billing_editAdjustment: 'Edit Adjustment',
  billing_deleteAdjustment: 'removeAdjustment',
  billing_diffCharge: 'Handle discrepancies',
  billing_cancelConfirm: 'cancelConfirmation',
  billing_batchConfirm: 'batchConfirmation',
  billing_reconciliationAmount: 'Reconciliation Amount',
  billing_exchangeRate: 'Exchange Rate',
  // billing_bill: 'Debit note/Credit note',
  billing_charges: 'feesandcharges',
  billing_business: 'Business',
  billing_recheck: 'Recheck',
  billing_cancelRecheck: 'Cancel recheck',
  billing_recheckTip: 'Please confirm the bill before reviewing it',
  billing_recheckStatus: 'Billing review status',
  billing_reviewPeople: 'Billing review people',
  billing_reviewDate: 'Billing review date',
  billingView_Determine: 'OK',
  billingView_Close: 'Close',
  includeAdjustmentCharge: 'Include adjustment charges',
  chargeList_query: 'Query',
  chargeList_newBill: 'New Bill',
  chargeList_startReconciliation: 'Start Reconciliation',
  chargeList_drawCollectInvoice: 'Draw/Collect Invoice',
  chargeList_writeOff: 'Write-Off',
  chargeList_applyForPayment: 'Request Withdrawal',
  chargeList_submission: 'Submit',
  chargeList_cancelSubmit: 'Cancel Submit',
  chargeList_revenueAndExpenditureMethod: 'Revenue And Expenditure Method',
  chargeList_invoiceRevenueAndExpenditureMethod: 'Invoice Revenue And Expenditure Method',
  chargeList_receivables: 'Receivables',
  chargeList_payables: 'Payables',
  chargeList_all: 'All',
  chargeList_feeType: 'cost type',
  chargeList_domestic: 'Domestic',
  chargeList_international: 'Overseas',
  chargeList_reconciliationType: 'Reconciliation Type',
  chargeList_accordingToCharges: 'accordingto fees and charges',
  chargeList_accordingToBusiness: 'According To Business',
  chargeList_cancelReconciliation: 'Cancel Reconciliation',
  chargeList_saveReconciliation: 'Save Reconciliation',
  chargeList_newAdjustment: 'New Adjustment',
  chargeList_editAdjustment: 'Edit Adjustment',
  chargeList_deleteAdjustment: 'removeAdjustment',
  chargeList_diffCharge: 'Handle discrepancies',
  chargeList_cancelConfirm: 'cancelConfirmation',
  chargeList_batchConfirm: 'batchConfirmation',

  billingCharge_businessNumber: 'Job No.',
  billingCharge_consignationCompany: 'Consignation Company',
  billingCharge_settlementCompany: 'Settlement Company',
  billingCharge_mblNo: 'MBL',
  billingCharge_vessel: 'MotherVessel',
  billingCharge_voyage: 'VoyageNumber',
  billingCharge_carrier: 'Carrier',
  billingCharge_billNo: 'Bill No',
  billingCharge_invoiceNo: 'Invoice No',
  billingCharge_itemNo: 'ReferenceNumber',
  billingCharge_businessType: 'ShippingType',
  billingCharge_businessStatus: 'ShippingStatus',
  billingCharge_solicitationType: 'Source of Freight',
  billingCharge_chargeItem: 'Designation of charges',
  billingCharge_feeStatus: 'charges payment status',
  billingCharge_confirmStatus: 'Confirm Status',
  billingCharge_businessDate: 'Job Date',
  billingCharge_amountRange: 'Amount Range',
  billingCharge_receivablesInvoicingDate: 'Receivables Invoicing Date',
  billingCharge_currency: 'Currency',
  billingCharge_operation: 'Operation',
  billingCharge_sales: 'Sales',
  billingCharge_advanceMoneyForAnotherOrNot: 'disbursement or not',
  billingCharge_adjustedOrNot: 'adjust or not',
  billingCharge_wroteOffOrNot: 'writtenoff or not',
  billingCharge_generatedBillsOrNot: 'bills issued or not',
  billingCharge_invoicedOrNot: 'invoice issued or not',
  billingCharge_appliedForPaymentOrNot: 'withdrawal requested or not',
  billingCharge_drawABbillOrNot: 'invoices required or not',
  billingCharge_department: 'Department',
  billingCharge_contactPerson: 'Contact Person',
  billingCharge_settlementType: 'Settlement Type',
  billingCharge_invoicingMethod: 'Invoicing Method',
  billingCharge_accrued: 'Accrued',
  billingCharge_receivablesInvoicingStatus: 'Receivables Invoicing Status',
  billingCharge_bookingNo: 'Booking No',
  billingCharge_unitPrice: 'Unit-Price',
  billingCharge_invoiceHeader: 'invoice title',
  billingCharge_businessReferenceNumber: 'Job reference number',
  billingCharge_warehouseNo: 'warehouse in no',
  billingCharge_vesselAndVoyage: 'vessel/voyage no',
  billingCharge_portOfLoading: 'Port Of Loading',
  billingCharge_portOfDestination: 'Port Of Destination',
  billingCharge_financialDate: 'financial Date',
  billingCharge_domesticOrInternational: 'domestic and overseas',
  billingCharge_paymentType: 'Payment Type',
  billingCharge_amount: 'Amount',
  billingCharge_taxIncludedPrice: 'taxInclusivePrice',
  billingCharge_taxExcludedPrice: 'taxExclusivePrice',
  billingCharge_taxAmount: 'Tax Amount',
  billingCharge_theAmountOfWriteOffs: 'Paid Amount',
  billingCharge_amountNotWrittenOff: 'Amount Not Clearance',
  billingCharge_reconciliationAmount: 'Reconciliation Amount',
  billingCharge_difference: 'Difference',
  billingCharge_confirmationRemarks: 'Confirmation Remarks',
  billingCharge_confirmState: 'Confirm State',
  billingCharge_creator: 'Creator',
  billingCharge_dateCreated: 'Date Created',
  billingCharge_remarks: 'Remarks',

  billingJob_businessNumber: 'Job No.',
  billingJob_consignationCompany: 'Consignation Company',
  billingJob_settlementCompany: 'Settlement Company',
  billingJob_mblNo: 'MBL',
  billingJob_vessel: 'MotherVessel',
  billingJob_voyage: 'VoyageNumber',
  billingJob_carrier: 'Carrier',
  billingJob_billNo: 'Bill No',
  billingJob_invoiceNo: 'Invoice No',
  billingJob_itemNo: 'ReferenceNumber',
  billingJob_businessType: 'ShippingType',
  billingJob_soNo: 'SO NO',
  billingJob_businessStatus: 'ShippingStatus',
  billingJob_solicitationType: 'Source of Freight',
  billingJob_chargeItem: 'Designation of charges',
  billingJob_feeStatus: 'charges payment status',
  billingJob_confirmStatus: 'Confirm Status',
  billingJob_businessDate: 'JobDate',
  billingJob_amountRange: 'Amount Range',
  billingJob_receivablesInvoicingDate: 'Receivables Invoicing Date',
  billingJob_currency: 'Currency',
  billingJob_operation: 'Operation',
  billingJob_sales: 'Sales',
  billingJob_advanceMoneyForAnotherOrNot: 'disbursement or not',
  billingJob_adjustedOrNot: 'adjust or not',
  billingJob_wroteOffOrNot: 'writtenoff or not',
  billingJob_generatedBillsOrNot: 'bills issued or not',
  billingJob_invoicedOrNot: 'invoice issued or not',
  billingJob_appliedForPaymentOrNot: 'withdrawal requested or not',
  billingJob_drawABbillOrNot: 'invoices required or not',
  billingJob_department: 'Department',
  billingJob_contactPerson: 'Contact Person',
  billingJob_settlementType: 'Settlement Type',
  billingJob_invoicingMethod: 'Invoicing Method',
  billingJob_accrued: 'Accrued',
  billingJob_receivablesInvoicingStatus: 'Receivables Invoicing Status',
  billingJob_bookingNo: 'Booking No',
  billingJob_unitPrice: 'Unit-Price',
  billingJob_invoiceHeader: 'invoice title',
  billingJob_businessReferenceNumber: 'Job reference number',
  billingJob_warehouseNo: 'warehouse in no',
  billingJob_vesselAndVoyage: 'vessel/voyage no',
  billingJob_portOfLoading: 'Port Of Loading',
  billingJob_portOfDestination: 'Port Of Destination',
  billingJob_financialDate: 'financial Date',
  billingJob_domesticOrInternational: 'domestic and overseas',
  billingJob_paymentType: 'Payment Type',
  billingJob_amount: 'Amount',
  billingJob_taxIncludedPrice: 'taxInclusivePrice',
  billingJob_taxExcludedPrice: 'taxExclusivePrice',
  billingJob_taxAmount: 'Tax Amount',
  billingJob_theAmountOfWriteOffs: 'Paid Amount',
  billingJob_amountNotWrittenOff: 'Amount Not Clearance',
  billingJob_reconciliationAmount: 'Reconciliation Amount',
  billingJob_difference: 'Difference',
  billingJob_confirmationRemarks: 'Confirmation Remarks',
  billingJob_ReviewRemarks: 'Review Remarks',
  InquiryLetterRemark: 'Inquiry Letter Remark',
  WarmPromptAppend: 'Tip: The remarks filled in will be appended after the original financial remarks.',
  WarmPromptOverwrite: 'Tip: The remarks filled in will overwrite the original inquiry letter remarks.',
  billingJob_confirmState: 'Confirm State',
  billingJob_creator: 'Creator',
  billingJob_dateCreated: 'Date Created',
  billingJob_remarks: 'Remarks',
  billingJob_customerLevel: 'Customer Level',
  billingJob_settlementMethod: 'Settlement Method',
  billingJob_chargesContactPerson: 'Charges Contact Person',
  billingJob_confirmUser: 'Confirmation User',
  // billingJob_settlementType: 'Settlement Type',
  // billingJob_invoiceHeader: 'invoice title',
  billingJob_settleAccountsTo: 'settlement object',
  billingJob_otherPartyBilling: 'other accountStatementNo',
  billingJob_customer: 'Customer',
  billingJob_portOfDischarge: 'Port of Discharge',
  billingJob_dateOfDeparture: 'Date Of Departure',
  billingJob_bookingAgent: 'Booking Agent',
  billingJob_revenueAndExpenditureType: 'Type',
  billingJob_chargesTotalAmount: 'Charges Total Amount',
  billingJob_dateOfArrival: 'Date Of Arrival',
  billingJob_billDate: 'Bill Date',
  billingJob_invoiceDate: 'Invoice Date',
  billingJob_originalCurrency: 'Original Currency',
  billingJob_billAndCurrency: 'Bill Currency',
  billing_billAmount: 'Bill Amount',
  billingJob_operationDepartment: 'Operation Department',
  billingJob_generatedAccountStatement: 'Generated Account Statement Or Not',
  billingJob_wroteOff: 'Wrote Off Or Not',
  billingJob_aging: 'Aging(days)',
  billingJob_agentBillNo: 'Agent Bill No',
  billingJob_billStatus: 'Bill Status',
  billingJob_accountStatementNo: 'Account Statement No',
  billingJob_invoicingRequirements: 'Invoicing Requirements',
  billingJob_proofDate: 'Financial Vouchers Date',
  billingJob_customerService: 'Customer Service',
  billingJob_invoicingStatus: 'Invoicing Status',
  billingJob_writeOffStatus: 'Write Off Status',
  billingJob_writeOffStatus_bill: 'Write Off Status',
  billingJob_writeOffStatus_reconciliation: 'Write Off Status',
  billingJob_amountOfMoney: 'Bill Amount',
  billingJob_notInvoicedMoney: 'uninvoiced amount',
  billingJob_totalCurrency: 'TotalByCurrency',
  billingJob_totalAmountNotWrittenOff: 'Total Amount Not Clearance',
  billingJob_taxRate: 'Tax Rate',
  billingJob_customJobType: 'Customized Job Type',
  billingJob_voyageLine: 'ShippingRoute',
  billingJob_separateNumber: 'House B/L Number',
  billingJob_dateTo: 'To',
  billingJob_lockCheckBoxDate: 'Query Data For Only Two Years',
  billingJob_inputDateNotEmpty: 'InputDate Not Empty',
  billingJob_unlockInputDateQuery: 'Query Data Two Years Ago, May Be Slower, Determine The Cancel Date Lock?',
  billingJob_billPaymentDate: 'withdrawal requested date',
  billingJob_billPaymentDateNotEmpty: 'withdrawal requested date not empty',
  billingJob_unlockBillPaymentDateQuery: 'Query Data Two Years Ago, May Be Slower, Determine The Cancel Date Lock?',
  billingJob_userDefinedField1: 'UserDefinedField1',
  billingJob_userDefinedField2: 'UserDefinedField2',
  billingJob_userDefinedField3: 'UserDefinedField3',
  billingJob_userDefinedField4: 'UserDefinedField4',
  billingJob_markDate: 'MarkDate',
  billingJob_markUser: 'MarkUser',
  billingJob_markStatus: 'MarkStatus',
  billingJob_mark: 'Mark',
  billingJob_vesselAndVoyageAndFlight: 'Vessel Voyage Flight',
  billingJob_billPaymentOrNot: 'BillPayment Or Not',
  billingJob_voyageAndFlight: 'Voyage And Flight',
  billingJob_containerDescription: 'FinalCommodityDescription',
  billingJob_InputDate: 'Statement document date',

  billingView_total: 'Total',
  billingView_query: 'Query',
  billingView_newAccountStatement: 'New Account Statement',
  billingView_edit: 'Edit',
  billingView_delete: 'Delete',
  billingView_view: 'View',
  billingView_confirm: 'Confirm',
  billingView_cancelConfirmation: 'cancelConfirmation',
  billingView_print: 'Print',
  billingView_drawCollectInvoice: 'Draw/Collect invoice',
  billingView_writeOff: 'Write-Off',
  billingView_applyForPayment: 'Request withdraw',
  billingView_revenueAndExpenditureMethod: 'Revenue and Expenditure Method',
  billingView_receivables: 'Receivables',
  billingView_payables: 'Payables',
  billingView_all: 'ALL',
  billingView_billType: 'Bill Type',
  billingView_domestic: 'Domestic',
  billingView_international: 'Overseas',
  billingView_reconciliationType: 'Reconciliation type',
  billingView_accordingToBusiness: 'According to business',
  billingView_accordingToCharges: 'accordingto fees and charges',

  billingForm_taxAmount: 'Tax Amount',
  billingForm_taxFreeAmount: 'Tax Free Amount',
  billingForm_bankOfDeposit: 'Bank Of Deposit',
  billingForm_bankAccount: 'Bank Account',
  billingForm_collectAndPrepaidOrNot: 'Collect or Prepaid',
  billingForm_unit: 'Unit',

  billingAccount_accountStatementType: 'Account Statement Type',
  billingAccount_writeOffOrNot: 'Write-Off or not',
  billingAccount_invoicingInformation: 'Invoicing Information',

  billingGroup_dateOfFiling: 'InvoiceDate',
  billingGroup_settleAccountsTo: 'Settlement Object',
  billingGroup_invoicingAddress: 'Invoicing Address',
  billingGroup_addBill: 'Add Bill',
  billingGroup_deleteBill: 'Delete Bill',
  billingGroup_previous: 'Previous',
  billingGroup_next: 'Next',
  billingJob_settlementAgent: 'Settlement Agent',
  billingJob_billingCreator: 'Billing Creator',

  Query: 'Query',
  View: 'View',
  Add: 'Add',
  Edit: 'Edit',
  Delete: 'Delete',
  print: 'Print',
  statistics: 'Statistics',
  ExportAllExcel: 'Export all Excel',
  BusinessNo: 'Job Number',
  WarehouseNo: 'warehouse in no',
  WayBillNumber: 'BillofLadingNumber',
  Destination: 'Destination',
  PortOfDestination: 'Port of Dest',
  WarehouseEntryTime: 'StorageTime',
  DeliveryTime: 'Delivery Time',
  DataEntryClerk: 'Inputer',
  Dataentryclerk: 'Inputer',
  NumberOfCases: 'NumberOfPackages',
  Weight: 'Weight',
  Volume: 'Volume',
  ComputationIsAffectedByDampness: 'DamagedMoisture',
  IntoTheWarehousePhotos: 'IntoTheWarehousePhotos',
  WarehouseName: 'WarehouseName',
  Warehouseman: 'WarehouseClerk',
  StorageLocation: 'Storage Location',
  Receiptnumber: 'Receipt Number',
  BlNo: 'B/LNo',
  UploadFile: 'Upload File',
  batchdownload: 'Batch Download',
  ResetFilter: 'ResetFilter',
  billingCharge_billingGroupNo: 'BillingGroupNo',
  modifiedBy: 'Modified By',
  dateModified: 'Date Modified',

  invoiceHeader: 'Invoice Header',
  revenueOrExpenditure: 'RevenueOrExpenditure',
  InvoicingAmount: 'InvoicingAmount',
  invoicingExchangeRate: 'InvoicingExchangeRate',
  invoiceInformation: 'InvoiceInformation',
  LoadingPort: 'LoadingPort',
  seaportOfDischarge: 'Port of Discharge(seaport)',
  billingJob_confirmDate: 'Billing Confirm Time',
  billingJob_theAmountOfNotWriteOffs: 'Balance Amount',
  QueryAgencyShareBill: 'Query Agency Share Bill',
  ForceDeleteBilling: '{0} bill {1} cannot be deleted forcibly.',
  HasBillPayment: 'Paid application',
  HasBillingGroup: 'Statement created',
  HasWriteOff: 'Written off',
  HasClosingAccount: 'Closed account',
  OppositeBillNoAlreadyExists: '<strong>Opposite bill No</strong> already exists, continue?',
  DueDate: 'Charge due date',
  DueDateDirty: 'Charge due date dirty',
  InCalculation: 'In calculation',
  NotCalculated: 'Not calculated',
  Calculated: 'Calculated',
  CancelConfirmedBillSameTime: 'Cancel the confirmed bill at the same time?',
  BillingConfirmStatus: 'Billing confirm status',
  ApplyForInvoicing: 'Apply for invoicing',
  BillSettlementType: 'Bill settlement type',
  CostCannotExceed3Currencies: 'Cost cannot exceed 3 currencies',
  DomesticBill: 'Domestic bill',
  Currency: 'Currency',
  CannotRemoveAllFees: 'Cannot remove all fees!',
  InvalidDate: 'invalid Date',
  Bill: 'Bill:',
  Billing_Requirements: 'Billing requirements',
  ForeignInvoiceTime: 'Foreign invoice issuance time'
}
